module.exports = __webpack_public_path__ + "img/badminton-dark.3d534252.svg";